<script setup lang="ts">
import { AMaybeRouterLink } from '@absolutins/ui-kit'
import { computed } from 'vue'

import type { TheLinkProps } from './types'

import { LocationIcon, PhoneIcon } from '../../icons'

const props = withDefaults(defineProps<TheLinkProps>(), {
  type: null,
})

const iconComponent = computed(() => {
  switch (props.type) {
    case 'phone':
      return PhoneIcon
    case 'location':
      return LocationIcon
    default:
      return null
  }
})
</script>

<template>
  <a-maybe-router-link
    class="the-link"
    v-bind="props"
  >
    <component
      :is="iconComponent"
      v-if="iconComponent"
      class="the-link__icon"
    />
    <slot />
  </a-maybe-router-link>
</template>

<style scoped lang="scss">
.the-link {
  all: unset;

  @include typography-const-button-link-large;

  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  cursor: pointer;
  gap: 4px;
  transition: color var(--ains-anim-main-250-out);

  &:active {
    color: var(--ains-color-main-primary);
  }

  @include media-hover-device {
    &:hover {
      color: var(--ains-color-main-primary);
    }
  }

  &__icon {
    width: 20px;
    height: 20px;
    color: var(--ains-color-main-primary);
  }
}
</style>
